import apiClient from "../apiClient";

//................. Wallet Api's...................//

export const getBalance = () => apiClient.post("/GetBalance");

export const getActiveOperator = (data) =>
  apiClient.post("/GetOperatorsActive", data);

export const getOperatorType = () => apiClient.post("/GetOpTypes");

//................. User Api's...................//

export const getUserList = (params) =>
  apiClient.get("/User/UserList", { params });

export const getUserRoles = () => apiClient.get("/User/GetRoles");

export const createUser = (data) => apiClient.post("/User/CreateUser", data);

export const changePinOrPassword = (data) =>
  apiClient.post("/ChangePinOrPassword", data);

//................. Profile & KYC Api's...................//

export const getProfile = () => apiClient.get("/Profile/Get");

export const updateProfile = (data) => apiClient.post("/Profile/Update", data);

export const uploadProfilePic = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiClient.post("/UploadProfilePic", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 60000,
  });
};

export const getKycDocuments = () => apiClient.get("/KYC/DocumentDetails");

export const uploadKycFile = (docTypeId, file) => {
  const formData = new FormData();
  formData.append("dtype", docTypeId);
  formData.append("file", file);
  return apiClient.post("/KYC/UploadFile", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 60000,
  });
};

// Fleet Owner can only apply (status 2) — approval is done by admin
export const applyKyc = () => apiClient.post("/KYC/UpdateStatus", {});

//................. Consumer Account Api's...................//

export const getConsumerList = (params) =>
  apiClient.get("/Consumer/List", { params });

export const saveConsumer = (data) => apiClient.post("/Consumer/Save", data);

// Returns the .xlsx as a Blob
export const downloadConsumerTemplate = () =>
  apiClient.get("/Consumer/DownloadTemplate", { responseType: "blob" });

const EXCEL_MIME = {
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xls: "application/vnd.ms-excel",
};

export const bulkUploadConsumer = (file) => {
  // Browsers can send .xlsx with an empty/octet-stream type (e.g. no Excel
  // installed) — re-wrap it with the real Excel type so the API accepts it
  const ext = file.name.split(".").pop().toLowerCase();
  const excelFile = new File([file], file.name, {
    type: EXCEL_MIME[ext] || file.type,
  });
  const formData = new FormData();
  formData.append("file", excelFile, file.name);
  return apiClient.post("/Consumer/BulkUpload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 60000,
  });
};

//................. Bills & Payments Api's...................//

// params: { year, month } — both optional, default to the current month
export const getBillCalendar = (params) =>
  apiClient.get("/Bills/Calendar", { params });

// params: { date } for one day, or { from, to } for a range (YYYY-MM-DD)
export const getDueBills = (params) => apiClient.get("/Bills/Due", { params });

// params: { status } — 0 all, 1 pending, 2 approved, 3 processing, 4 processed, 5 rejected, 6 withdrawn
export const reviewBills = (data) => apiClient.post("/Bills/Review", data);

export const createBatch = (data) =>
  apiClient.post("/Bills/Batch/Create", data);

export const getBatchList = (params) =>
  apiClient.get("/Bills/Batch/List", { params });

// Batch + items + audit + which buttons this user may press
export const getBatchDetail = (id) => apiClient.get(`/Bills/Batch/${id}`);

// Remark optional
export const approveBatch = (id, data) =>
  apiClient.post(`/Bills/Batch/${id}/Approve`, data);

// Remark required, at least 5 characters
export const rejectBatch = (id, data) =>
  apiClient.post(`/Bills/Batch/${id}/Reject`, data);

// Maker only, own pending batch — no body
export const withdrawBatch = (id) =>
  apiClient.post(`/Bills/Batch/${id}/Withdraw`);

//................. Report Api's...................//

export const getRechargeReport = (data) =>
  apiClient.post("/RechargeReport", data);

export const getLedgerReport = (data) => apiClient.post("/LedgerReport", data);

//................. Fund Request Api's...................//

export const getFundRequestBanks = () =>
  apiClient.get("/FundRequest/FundRequestBanks");

export const getPaymentModeByBank = (bankId) =>
  apiClient.post("/FundRequest/BindPaymentMode", { BankID: bankId });

export const uploadFundReceipt = (bankId, file) => {
  const formData = new FormData();
  formData.append("BankID", bankId);
  formData.append("File", file);
  return apiClient.post("/FundRequest/UploadReceipt", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const submitFundRequest = (data) =>
  apiClient.post("/FundRequest/FundRequestSubmit", data);

export const getFundOrderReport = (data) =>
  apiClient.post("/FundRequest/FundOrderReport", data);
